export const getCookie = (name) => {
  const pattern = RegExp(name + '=.[^;]*');
  const matched = document.cookie.match(pattern);
  if (matched) {
    const cookie = matched[0].split('=');
    return cookie[1];
  }
  return false;
};

export const setCookie = (cookieName, value) => {
  document.cookie = cookieName + '=' + value + ';path=/';
};

export const arrayMapToObjectMap = (arrayList, key) => {
  const obj = {};
  arrayList.map((item) => obj[item[key]] = item);  //eslint-disable-line
  return obj;
};
